<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56.693" height="56.693" viewBox="0 0 56.693 56.693">
    <path id="Path_1" data-name="Path 1" d="M28.347,0A28.347,28.347,0,1,0,56.693,28.346,28.346,28.346,0,0,0,28.347,0m17,39.691-5.656,5.657L28.347,34,17,45.348l-5.656-5.657L22.69,28.346,11.345,17,17,11.344,28.347,22.69,39.692,11.344,45.348,17,34,28.346Z" fill="currentColor"/>
  </svg>
</template>
